export const PRODUCT_STATUS = {
  PUBLISHED: 'Published',
  DRAFT: 'Draft'
};
